import React, { useState } from 'react';
import styles from './PricingLetter.module.scss';
import FounderLetterModal from '../../landingPageComponents/FounderLetter/FounderLetterModal';

const PricingLetter = () => {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <section id="pricing-letter" className={styles.section}>
            <div className={styles.card}>
                <div className={styles.cardTop}>
                    <div className={styles.iconCircle} aria-hidden="true">
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="2" y="6" width="22" height="15" rx="2.5" stroke="white" strokeWidth="2" fill="none" />
                            <path d="M2 9.5l11 7 11-7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <span className={styles.label}>A LETTER TO OUR COMMUNITY</span>
                </div>

                <h2 className={styles.heading}>Dear Prepal Founding Members,</h2>
                <p className={styles.body}>
                    We started Prepal because we believe every student deserves access to the kind of
                    personalized, expert guidance that was once reserved for the few. As founding members,
                    you're not just early adopters — you're shaping the future of SAT preparation.
                    Your feedback, your stories, and your results will define what Prepal becomes.
                    We're incredibly grateful you're here from the very start.
                </p>
                <button className={styles.readMoreBtn} onClick={() => setModalOpen(true)}>
                    Read more
                </button>
            </div>
            <FounderLetterModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
        </section>
    );
};

export default PricingLetter;
